import { useEffect, useState } from "react";
import "./testimonial.scss";
import { getProjectById } from "../../data/ProjectsData";
import buttonsLogo from "../../assets/buttons_logo.webp";
const Testimonial = ({ projectId }) => {
  const [project, setProject] = useState();

  useEffect(() => {
    if (projectId === "BUTTONS") {
      setProject({
        testimonialLogo: buttonsLogo,
        name: "BUTTONS",
        testimonialContent: `Render X Architects gave our store a fresh look with thoughtful interior design. The space feels organized, stylish, and perfect for our customers.`,
        testimonialBorderColor: "#020db8",
      });
    } else {
      setProject(getProjectById(projectId));
    }
  }, []);
  return (
    <div className="testimonials_main">
      <div className="testimonials_container">
        <img src={project?.testimonialLogo} alt="" />
        <div className="testimonial_content">
          <h3>{project?.name}</h3>
          <p>{project?.testimonialContent}</p>
        </div>
      </div>
      <div
        className="testimonial_border_end"
        style={{ backgroundColor: "black" }}
      ></div>
    </div>
  );
};

export default Testimonial;
